import EventRegistration from './EventRegistration';
export default EventRegistration;
